// @ts-nocheck
import { Card, CardBody, CardExpandToggler } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import Bar from '@pages/dashboard/Bar';
import Pie from '@pages/dashboard/Pie';
import { getEquipmentsCountDP } from '@store/FLEET/Equipments/equipmentsSlice';
import { useAppDispatch } from '@store/hooks';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';

// const FleetDashboard = () => {
//   const dispatch = useAppDispatch();
//   const { i18n } = useTranslation();

//   const [data, setData] = useState();
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const [vehicleStatusData, setVehicleStatusData] = useState({ labels: [], series: [] });
//   const [driverStatusData, setDriverStatusData] = useState({ labels: [], series: [] });
//   const [mostUsedVehicles, setMostUsedVehicles] = useState({ labels: [], series: [] });

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const res = await dispatch(getEquipmentsCountDP()).unwrap();
//         if (res.succeeded) {
//           setData(res.data);
//         } else {
//           setData(null);
//           setError(i18n.language === 'en' ? 'Failed to fetch data' : 'فشل في جلب البيانات');
//         }
//       } catch (err) {
//         setData(null);
//         setError(i18n.language === 'en' ? 'Error while fetching data' : 'حدث خطأ أثناء جلب البيانات');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [dispatch, i18n.language]);

//   useEffect(() => {
//     if (data) {
//       setVehicleStatusData({
//         labels:
//           i18n.language === 'en' ? ['Active', 'Inactive', 'Under Maintenance'] : ['نشط', 'غير نشط', 'تحت الصيانة'],
//         series: [
//           data.equipmentsActiveCount ?? 0,
//           data.equipmentsInactiveCount ?? 0,
//           data.equipmentsWorkOrderServicingCount ?? 0
//         ]
//       });

//       setDriverStatusData({
//         labels: i18n.language === 'en' ? ['Assigned', 'Free'] : ['معين', 'حر'],
//         series: [data.driversAssignmentCount ?? 0, data.driversFreeCount ?? 0]
//       });

//       const top5Data = (data.equipmentsOdometerList ?? [])
//         .slice()
//         .sort((a, b) => b.odometer - a.odometer)
//         .slice(0, 5);

//       setMostUsedVehicles({
//         labels: top5Data.map(item => item.equipmentName),
//         series: [
//           {
//             name: i18n.language === 'en' ? 'Distance (km)' : 'المسافة المقطوعة (كم)',
//             data: top5Data.map(item => item.odometer / 10000)
//           }
//         ]
//       });
//     }
//   }, [data, i18n.language]);

//   const formatDate = dateString => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: '2-digit',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   return (
//     <>
//       <Loading loading={loading} error={error}>
//         <div className='container-fluid'>
//           {/* الصف الأول - KPIs */}
//           <div className='row'>
//             <div className='col-xl-3 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-truck text-primary me-2 fs-4'></i>
//                     <span className='flex-grow-1'>{i18n.language === 'en' ? 'Total Vehicles' : 'إجمالي المركبات'}</span>
//                   </div>
//                   <h3 className='mb-0'>{data?.equipmentsCount}</h3>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-xl-3 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-activity text-success me-2 fs-4'></i>
//                     <span className='flex-grow-1'>
//                       {i18n.language === 'en' ? 'Utilization Rate' : 'معدل الاستخدام'}
//                     </span>
//                   </div>
//                   <h3 className='mb-0 text-success'>
//                     {Math.round((data?.equipmentsActiveCount / data?.equipmentsCount) * 100)}%
//                   </h3>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-xl-3 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-person-check text-info me-2 fs-4'></i>
//                     <span className='flex-grow-1'>
//                       {i18n.language === 'en' ? 'Assigned Vehicles' : 'المركبات المعينة'}
//                     </span>
//                   </div>
//                   <h3 className='mb-0 text-info'>{data?.equipmentsAssignmentCount}</h3>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-xl-3 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-person-dash text-secondary me-2 fs-4'></i>
//                     <span className='flex-grow-1'>
//                       {i18n.language === 'en' ? 'Unassigned Vehicles' : 'المركبات غير المعينة'}
//                     </span>
//                   </div>
//                   <h3 className='mb-0 text-secondary'>{data?.equipmentsUnAssignmentCount}</h3>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>

//           {/* الصف الثاني - الصيانة */}
//           <div className='row'>
//             <div className='col-xl-6 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-wrench-adjustable-circle text-danger me-2 fs-4'></i>
//                     <span className='flex-grow-1'>
//                       {i18n.language === 'en' ? 'Maintenance Order' : 'أوامر الصيانة'}
//                     </span>
//                   </div>
//                   <h3 className='mb-0 text-danger'>{data?.equipmentsWorkOrderCount}</h3>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-xl-6 col-lg-6'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-wrench-adjustable-circle text-warning me-2 fs-4'></i>
//                     <span className='flex-grow-1'>
//                       {i18n.language === 'en' ? 'Maintenance Request' : 'طلبات الصيانة'}
//                     </span>
//                   </div>
//                   <h3 className='mb-0 text-warning'>{data?.equipmentsWorkRequestsCount}</h3>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>

//           {/* الصف الثالث - المخططات */}
//           <div className='row g-3'>
//             <div className='col-md-6 col-lg-4'>
//               <Card className='mb-3 h-100'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3'>
//                     <span className='flex-grow-1 fs-6 fw-bold'>
//                       {i18n.language === 'en' ? 'Vehicle Status' : 'حالة المركبات'}
//                     </span>
//                     <CardExpandToggler />
//                   </div>
//                   <Pie labels={vehicleStatusData.labels} series={vehicleStatusData.series} height={230} />
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-md-6 col-lg-4'>
//               <Card className='mb-3 h-100'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3'>
//                     <span className='flex-grow-1 fs-6 fw-bold'>
//                       {i18n.language === 'en' ? 'Driver Status' : 'حالة السائقين'}
//                     </span>
//                     <CardExpandToggler />
//                   </div>
//                   <Pie labels={driverStatusData.labels} series={driverStatusData.series} height={230} />
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-md-6 col-lg-4'>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-arrow-left-circle text-success me-2 fs-4'></i>
//                     <span className='flex-grow-1'>{i18n.language === 'en' ? 'Last Handover' : 'آخر تسليم'}</span>
//                   </div>
//                   <div className='ms-5'>
//                     <div className='d-flex align-items-center mb-2'>
//                       <i className='bi bi-truck me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Vehicle:' : 'المركبة:'}</span>
//                       <span className='ms-2 fw-medium'>{data?.lastHandOver.equipmentName}</span>
//                     </div>
//                     <div className='d-flex align-items-center mb-2'>
//                       <i className='bi bi-person me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Driver:' : 'السائق:'}</span>
//                       <span className='ms-2 fw-medium'>
//                         {data?.lastHandOver.driverName2 || data?.lastHandOver.driverName}
//                       </span>
//                     </div>
//                     <div className='d-flex align-items-center'>
//                       <i className='bi bi-calendar me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Date:' : 'التاريخ:'}</span>
//                       <span className='ms-2 fw-medium'>{formatDate(data?.lastHandOver.handOverDate)}</span>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//               <Card className='mb-3 shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3 align-items-center'>
//                     <i className='bi bi-arrow-right-circle text-info me-2 fs-4'></i>
//                     <span className='flex-grow-1'>{i18n.language === 'en' ? 'Last Takeover' : 'آخر استلام'}</span>
//                   </div>
//                   <div className='ms-5'>
//                     <div className='d-flex align-items-center mb-2'>
//                       <i className='bi bi-truck me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Vehicle:' : 'المركبة:'}</span>
//                       <span className='ms-2 fw-medium'>{data?.lastTakeOver.equipmentName}</span>
//                     </div>
//                     <div className='d-flex align-items-center mb-2'>
//                       <i className='bi bi-person me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Driver:' : 'السائق:'}</span>
//                       <span className='ms-2 fw-medium'>
//                         {data?.lastTakeOver.driverName2 || data?.lastTakeOver.driverName}
//                       </span>
//                     </div>
//                     <div className='d-flex align-items-center'>
//                       <i className='bi bi-calendar me-2 text-muted'></i>
//                       <span className='text-muted'>{i18n.language === 'en' ? 'Date:' : 'التاريخ:'}</span>
//                       <span className='ms-2 fw-medium'>{formatDate(data?.lastTakeOver.takeOverDate)}</span>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>

//           {/* الصف الرابع - آخر العمليات */}
//           <div className='row g-3 mt-2'>
//             <div className='col-md-12 col-lg-6'>
//               <Card className='mb-3 h-100'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3'>
//                     <span className='flex-grow-1 fs-6 fw-bold'>
//                       {i18n.language === 'en' ? 'Most Used Vehicles' : 'المركبات الأكثر استخداماً'}
//                     </span>
//                     <CardExpandToggler />
//                   </div>
//                   <Bar
//                     categories={mostUsedVehicles.labels}
//                     series={mostUsedVehicles.series}
//                     height={300}
//                     isHorizontal
//                   />
//                 </CardBody>
//               </Card>
//             </div>

//             <div className='col-6'>
//               <Card className='shadow'>
//                 <CardBody>
//                   <div className='d-flex fw-bold small mb-3'>
//                     <span className='flex-grow-1 fs-6 fw-bold'>
//                       {i18n.language === 'en' ? 'Vehicles Odometer Reading' : 'قراءة عداد المركبات'}
//                     </span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className='table-responsive'>
//                     <table className='table table-sm    table-hover'>
//                       <thead className='bg-theme'>
//                         <tr>
//                           <th>#</th>
//                           <th>{i18n.language === 'en' ? 'Vehicle Name' : 'اسم المركبة'}</th>
//                           <th>{i18n.language === 'en' ? 'Driver Name' : 'اسم السائق'}</th>
//                           <th>{i18n.language === 'en' ? 'Odometer (km)' : 'العداد (كم)'}</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {data?.equipmentsOdometerList.map((item, index) => (
//                           <tr key={index}>
//                             <td>{index + 1}</td>
//                             <td>{item.equipmentName2 || item.equipmentName}</td>
//                             <td>
//                               {item.driverName2 ||
//                                 item.driverName ||
//                                 (i18n.language === 'en' ? 'No Driver' : 'لا يوجد سائق')}
//                             </td>
//                             <td>{item.odometer.toLocaleString()}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

const StaticDashboard = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [vehicleStatusData, setVehicleStatusData] = useState({ labels: [], series: [] });
  const [driverStatusData, setDriverStatusData] = useState({ labels: [], series: [] });
  const [mostUsedVehicles, setMostUsedVehicles] = useState({ labels: [], series: [] });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await dispatch(getEquipmentsCountDP()).unwrap();
        if (res.succeeded) {
          setData(res.data);
        } else {
          setData(null);
          setError(i18n.language === 'en' ? 'Failed to fetch data' : 'فشل في جلب البيانات');
        }
      } catch (err) {
        setData(null);
        setError(i18n.language === 'en' ? 'Error while fetching data' : 'حدث خطأ أثناء جلب البيانات');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch, i18n.language]);

  useEffect(() => {
    if (data) {
      setVehicleStatusData({
        labels:
          i18n.language === 'en' ? ['Active', 'Inactive', 'Under Maintenance'] : ['نشط', 'غير نشط', 'تحت الصيانة'],
        series: [
          data.equipmentsActiveCount ?? 0,
          data.equipmentsInactiveCount ?? 0,
          data.equipmentsWorkOrderServicingCount ?? 0
        ]
      });

      setDriverStatusData({
        labels: i18n.language === 'en' ? ['Assigned', 'Free'] : ['معين', 'حر'],
        series: [data.driversAssignmentCount ?? 0, data.driversFreeCount ?? 0]
      });

      const top5Data = (data.equipmentsOdometerList ?? [])
        .slice()
        .sort((a, b) => b.odometer - a.odometer)
        .slice(0, 5);

      setMostUsedVehicles({
        labels: top5Data.map(item => item.equipmentName),
        series: [
          {
            name: i18n.language === 'en' ? 'Distance (km)' : 'المسافة المقطوعة (كم)',
            data: top5Data.map(item => item.odometer / 10000)
          }
        ]
      });
    }
  }, [data, i18n.language]);

  const formatDate = dateString => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // حساب معدل الاستخدام
  // const utilizationRate = Math.round((data?.equipmentsActiveCount / data?.equipmentsCount) * 100) || 0;
  const utilizationRate = Math.round((data?.equipmentsAssignmentCount / data?.equipmentsActiveCount) * 100) || 0;

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className='container-fluid'>
          {/* الصف الأول - KPIs */}
          <div className='row'>
            <div className='col-xl-3 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-truck text-primary me-2 fs-4'></i>
                    <span className='flex-grow-1'>{i18n.language === 'en' ? 'Total Vehicles' : 'إجمالي المركبات'}</span>
                  </div>
                  <h3 className='mb-0'>
                    <CountUp end={data?.equipmentsCount || 0} duration={2} separator=',' />
                  </h3>
                </CardBody>
              </Card>
            </div>

            <div className='col-xl-3 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-activity text-success me-2 fs-4'></i>
                    <span className='flex-grow-1'>
                      {i18n.language === 'en' ? 'Utilization Rate' : 'معدل الاستخدام'}
                    </span>
                  </div>
                  <h3 className='mb-0 text-success'>
                    <CountUp end={utilizationRate} duration={2} suffix='%' />
                  </h3>
                </CardBody>
              </Card>
            </div>

            <div className='col-xl-3 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-person-check text-info me-2 fs-4'></i>
                    <span className='flex-grow-1'>
                      {i18n.language === 'en' ? 'Assigned Vehicles' : 'المركبات المعينة'}
                    </span>
                  </div>
                  <h3 className='mb-0 text-info'>
                    <CountUp end={data?.equipmentsAssignmentCount || 0} duration={2} separator=',' />
                  </h3>
                </CardBody>
              </Card>
            </div>

            <div className='col-xl-3 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-person-dash text-secondary me-2 fs-4'></i>
                    <span className='flex-grow-1'>
                      {i18n.language === 'en' ? 'Unassigned Vehicles' : 'المركبات غير المعينة'}
                    </span>
                  </div>
                  <h3 className='mb-0 text-secondary'>
                    <CountUp end={data?.equipmentsUnAssignmentCount || 0} duration={2} separator=',' />
                  </h3>
                </CardBody>
              </Card>
            </div>
          </div>

          {/* الصف الثاني - الصيانة */}
          <div className='row'>
            <div className='col-xl-6 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-wrench-adjustable-circle text-danger me-2 fs-4'></i>
                    <span className='flex-grow-1'>
                      {i18n.language === 'en' ? 'Maintenance Order' : 'أوامر الصيانة'}
                    </span>
                  </div>
                  <h3 className='mb-0 text-danger'>
                    <CountUp end={data?.equipmentsWorkOrderCount || 0} duration={2} separator=',' />
                  </h3>
                </CardBody>
              </Card>
            </div>

            <div className='col-xl-6 col-lg-6'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-wrench-adjustable-circle text-warning me-2 fs-4'></i>
                    <span className='flex-grow-1'>
                      {i18n.language === 'en' ? 'Maintenance Request' : 'طلبات الصيانة'}
                    </span>
                  </div>
                  <h3 className='mb-0 text-warning'>
                    <CountUp end={data?.equipmentsWorkRequestsCount || 0} duration={2} separator=',' />
                  </h3>
                </CardBody>
              </Card>
            </div>
          </div>

          {/* الصف الثالث - المخططات */}
          <div className='row g-3'>
            <div className='col-md-6 col-lg-4'>
              <Card className='mb-3 h-100'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1 fs-6 fw-bold'>
                      {i18n.language === 'en' ? 'Vehicle Status' : 'حالة المركبات'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <Pie labels={vehicleStatusData.labels} series={vehicleStatusData.series} height={230} />
                </CardBody>
              </Card>
            </div>

            <div className='col-md-6 col-lg-4'>
              <Card className='mb-3 h-100'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1 fs-6 fw-bold'>
                      {i18n.language === 'en' ? 'Driver Status' : 'حالة السائقين'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <Pie labels={driverStatusData.labels} series={driverStatusData.series} height={230} />
                </CardBody>
              </Card>
            </div>

            <div className='col-md-6 col-lg-4'>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-arrow-left-circle text-success me-2 fs-4'></i>
                    <span className='flex-grow-1'>{i18n.language === 'en' ? 'Last Handover' : 'آخر تسليم'}</span>
                  </div>
                  <div className='ms-5'>
                    <div className='d-flex align-items-center mb-2'>
                      <i className='bi bi-truck me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Vehicle:' : 'المركبة:'}</span>
                      <span className='ms-2 fw-medium'>{data?.lastHandOver?.equipmentName || 'N/A'}</span>
                    </div>
                    <div className='d-flex align-items-center mb-2'>
                      <i className='bi bi-person me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Driver:' : 'السائق:'}</span>
                      <span className='ms-2 fw-medium'>
                        {data?.lastHandOver?.driverName2 || data?.lastHandOver?.driverName || 'N/A'}
                      </span>
                    </div>
                    <div className='d-flex align-items-center'>
                      <i className='bi bi-calendar me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Date:' : 'التاريخ:'}</span>
                      <span className='ms-2 fw-medium'>{formatDate(data?.lastHandOver?.handOverDate)}</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card className='mb-3 shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3 align-items-center'>
                    <i className='bi bi-arrow-right-circle text-info me-2 fs-4'></i>
                    <span className='flex-grow-1'>{i18n.language === 'en' ? 'Last Takeover' : 'آخر استلام'}</span>
                  </div>
                  <div className='ms-5'>
                    <div className='d-flex align-items-center mb-2'>
                      <i className='bi bi-truck me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Vehicle:' : 'المركبة:'}</span>
                      <span className='ms-2 fw-medium'>{data?.lastTakeOver?.equipmentName || 'N/A'}</span>
                    </div>
                    <div className='d-flex align-items-center mb-2'>
                      <i className='bi bi-person me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Driver:' : 'السائق:'}</span>
                      <span className='ms-2 fw-medium'>
                        {data?.lastTakeOver?.driverName2 || data?.lastTakeOver?.driverName || 'N/A'}
                      </span>
                    </div>
                    <div className='d-flex align-items-center'>
                      <i className='bi bi-calendar me-2 text-muted'></i>
                      <span className='text-muted'>{i18n.language === 'en' ? 'Date:' : 'التاريخ:'}</span>
                      <span className='ms-2 fw-medium'>{formatDate(data?.lastTakeOver?.takeOverDate)}</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>

          {/* الصف الرابع - آخر العمليات */}
          <div className='row g-3 mt-2'>
            <div className='col-md-12 col-lg-6'>
              <Card className='mb-3 h-100'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1 fs-6 fw-bold'>
                      {i18n.language === 'en' ? 'Most Used Vehicles' : 'المركبات الأكثر استخداماً'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <Bar
                    categories={mostUsedVehicles.labels}
                    series={mostUsedVehicles.series}
                    height={300}
                    isHorizontal
                  />
                </CardBody>
              </Card>
            </div>

            <div className='col-6'>
              <Card className='shadow'>
                <CardBody>
                  <div className='d-flex fw-bold small mb-3'>
                    <span className='flex-grow-1 fs-6 fw-bold'>
                      {i18n.language === 'en' ? 'Vehicles Odometer Reading' : 'قراءة عداد المركبات'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className='table-responsive'>
                    <table className='table table-sm table-hover'>
                      <thead className='bg-theme'>
                        <tr>
                          <th>#</th>
                          <th>{i18n.language === 'en' ? 'Vehicle Name' : 'اسم المركبة'}</th>
                          <th>{i18n.language === 'en' ? 'Driver Name' : 'اسم السائق'}</th>
                          <th>{i18n.language === 'en' ? 'Odometer (km)' : 'العداد (كم)'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.equipmentsOdometerList?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.equipmentName2 || item.equipmentName}</td>
                            <td>
                              {item.driverName2 ||
                                item.driverName ||
                                (i18n.language === 'en' ? 'No Driver' : 'لا يوجد سائق')}
                            </td>
                            <td>
                              <CountUp end={item.odometer || 0} duration={1} separator=',' />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </Loading>
    </>
  );
};

export default StaticDashboard;
